import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class TaskApi extends BaseApi {
  async getTaskList(
    params: APIPaths["/partner-app/task/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/partner-app/task/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/partner-app/task/list", { params })).data;
  }
}
